import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  contentCard: {
    height: 160,
    borderRadius: 10,
    marginTop: 20,
    paddingHorizontal: 70,
    paddingVertical: 40,
    width: "100%",
  },
  number: {
    fontWeight: "bold",
    fontSize: 22,
    lineHeight: 25,
    color: "#fff",
  },
  brand: {
    fontWeight: "bold",
    fontSize: 14,
    lineHeight: 25,
    color: "#fff",
  },
  deleteIcon: {
    position: "absolute",
    right: 10,
    top: 10,
  },
  imgBank: {
    width: 30,
    height: 19,
    position: "absolute",
    right: 10,
    bottom: 10,
  },
  btnAdd: {
    height: 50,
    width: "100%",
    borderColor: "#32BFB1",
    borderWidth: 2,
    borderRadius: 20,
    marginTop: 20,
  },
  textBtn: {
    textAlign: "center",
    marginTop: 15,
  },
  img_coin: {
    position: "absolute",
    left: 0,
    top: 25,
    width: 50,
    height: 108,
  },
  textNotFoundAccounts: {
    textAlign: "center",
    marginTop: 10,
    marginBottom: 10,
    fontWeight: "bold",
  },
});
